export const initFaqAccordion = () => {
  const accordionItems = document.querySelectorAll('.faq__item');

  accordionItems?.forEach((item) => {
    const button = item.querySelector('.faq__accordionBtn');

    button.addEventListener('click', function () {
      const isOpen = item.classList.contains('is-open');

      // Close all items
      accordionItems.forEach((el) => el.classList.remove('is-open'));

      // If the clicked item wasn't open, open it
      if (!isOpen) {
        item.classList.add('is-open');
      }
    });
  });
};
